import type { ButtonHTMLAttributes, FunctionComponent } from 'react';

import styles from './navButton.module.css';

export interface NavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const NavButton: FunctionComponent<NavButtonProps> = ({ children, ...rest }) => {
  return (
    <button data-testid="nav-button" className={styles.navButton} {...rest}>
      <div className={styles.navButton__innerWrapper}>{children}</div>
    </button>
  );
};
